import PL from './pl/feedback/feedback';
import EN_GB from './uk/feedback/feedback';
import UK from './ua/feedback/feedback';
import DE from './de/feedback/feedback';
import CS from './cs/feedback/feedback';
import RO from './ro/feedback/feedback';
import HU from './hu/feedback/feedback';
import SK from './sk/feedback/feedback';
import BG from './bg/feedback/feedback';
import FR from './fr/feedback/feedback';
import IT from './it/feedback/feedback';
import ES from './es/feedback/feedback';
import NL from './nl/feedback/feedback';
import SV from './sv/feedback/feedback';
import PT from './pt/feedback/feedback';
import DA from './da/feedback/feedback';
import FI from './fi/feedback/feedback';

export default {
    "pl": PL,
    "en-GB": EN_GB,
    "uk": UK,
    "de": DE,
    "cs": CS,
    "ro": RO,
    "hu": HU,
    "sk": SK,
    "bg": BG,
    "fr": FR,
    "it": IT,
    "es": ES,
    "nl": NL,
    "sv": SV,
    "pt": PT,
    "da": DA,
    "fi": FI    
}